import PropTypes from 'prop-types';
import Typography from '/components/Typography';

const CutStepTitle = ({ builderConfig, packConfig }) => {
	let titleText = 'What do you want to save a ton on?';
	let subtitleText;

	if (builderConfig.productConfigs?.titles?.[packConfig?.currentProductConfigIndex]) {
		titleText = builderConfig.productConfigs?.titles?.[packConfig?.currentProductConfigIndex];
	} else if (builderConfig?.showFullTitle) {
		titleText = builderConfig?.title;
		subtitleText = builderConfig?.subtitle;
	}

	return (
		<>
			<Typography component="h1" variant="subhead-md">
				{titleText}
			</Typography>
			{subtitleText && <Typography variant="subtitle-sm">{subtitleText}</Typography>}
		</>
	);
};

CutStepTitle.propTypes = {
	builderConfig: PropTypes.object,
	packConfig: PropTypes.object,
};

export default CutStepTitle;
